import React from 'react'
import styled from 'styled-components'

import logo from 'assets/logo.svg'
import Color from 'helpers/Color'
import Util from 'helpers/Util'

const Wrapper = styled.div`
  font-family: 'GothamRounded';
  font-size: 22px;
  color: ${Color.white};
  display: flex;
  margin: 10px 0;

  ${Util.mobileOnly} {
    font-size: 18px;
  }
`
const Icon = styled.img`
  height: 80px;

  ${Util.mobileOnly} {
    height: 60px;
  }
`
const Text = styled.div`
  margin: 22px 5px;

  ${Util.mobileOnly} {
    margin: 10px 5px;
  }
`
const Title = styled.div`
  margin-bottom : 5px;
`
const Description = styled.div`
  font-size: 85%;
`

const Logo = () => (
  <Wrapper>
    <Icon
      src={logo}
      alt='Radiator Labs Logo'
    />
    <Text>
      <Title>
        RadiatorLabs
      </Title>
      <Description>
        Building Management
      </Description>
    </Text>
  </Wrapper>
)

export default Logo



// WEBPACK FOOTER //
// ./src/components/UI/Logo.jsx